module.exports = __webpack_public_path__ + "img/Black-History.f4d6ef70.jpg";